
import * as PIXI from 'pixi.js'
// import { Viewport } from 'pixi-viewport'
import { OutlineFilter } from '@pixi/filter-outline';
global.PIXI = PIXI
require('pixi-projection')

// var geometric = require('geometric')

export default class Canvas {
  constructor (el, device) {
    this.onDragStart = this.onDragStart.bind(this)
    this.onDragEnd = this.onDragEnd.bind(this)
    this.onDragMove = this.onDragMove.bind(this)
    this.onMouseOver = this.onMouseOver.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)

    this.device = device

    this.app = new PIXI.Application({
      width: window.innerWidth,
      height: window.innerHeight,
      backgroundColor: 0xFF0000,
      autoResize: true,
      antialias: true,
      forceFXAA: true,
      resolution: window.devicePixelRatio || 1
    })

    // this.viewport = new Viewport({
    //   screenWidth: window.innerWidth,
    //   screenHeight: window.innerHeight,
    //   worldWidth: 1000,
    //   worldHeight: 1000,

    //   interaction: this.app.renderer.plugins.interaction // the interaction module is important for wheel to work properly when renderer.view is placed or scaled
    // })

    // this.app.stage.addChild(this.viewport)

    // this.viewport
    //   .pinch()

    el.appendChild(this.app.view)

    this.w = this.app.screen.width / 2
    this.h = this.app.screen.height / 2

    this.loader = new PIXI.Loader()
    this.texCache = PIXI.utils.TextureCache

    this.wait = false
    this.waiting = false
    this.scaleFactor = 1
    this.sto = null
    this.initiated = false

    this.origins = { w: 0, h: 0 }
  }

  init (collage) {
    // console.log('init', this.initiated)
    if (this.initiated) return
    const urlCorner = this.device.isMobile ? require('../assets/textures/corner-mobile.png') : require('../assets/textures/corner.png')
    this.preload([
      { id: collage.bg.uid, url: collage.bg.url },
      { id: collage.sentence.uid, url: collage.sentence.url },
      { id: 'collage-corner', url: urlCorner }
    ]).then((ressources) => {
      // console.log('---okokfff')
      this.addObjects(collage.bg.uid, collage.sentence.uid)

      // Listen for animate update
      this.app.ticker.add((delta) => {
        this.render()
      })

      this.resize()
      this.initiated = true
    })
  }

  getScaleFactor () {

  }

  setScaleFactor () {

  }

  scaleQuad (scaleFactor, origin) {
    // const vertices = []
    // // maybe use map
    // for (let i = 0; i < this.quad.length; i++) {
    //   const point = this.quad[i]
    //   vertices.push([point.x, point.y])
    // }

    // const newVertices = geometric.polygonScale(vertices, scaleFactor, origin)
    // const quad = this.quad
    // for (let i = 0; i < newVertices.length; i++) {
    //   quad[i].x = newVertices[i][0]
    //   quad[i].y = newVertices[i][1]
    // }

    // return quad
  }

  takeScreenshot () {
    if (this.sto) clearTimeout(this.sto)
    return new Promise((resolve, reject) => {
      this.wait = true
      this.beforeScreenshot()
      this.resetScale()

      this.app.renderer.extract.canvas(this.app.stage).toBlob((b) => {

        // const a = document.createElement('a')
        // document.body.append(a)
        // a.download = 'screenshot'
        // a.href = URL.createObjectURL(b)
        // a.click()
        // a.remove()

        this.sto = setTimeout(() => {
          resolve(URL.createObjectURL(b))
          this.afterScreenshot()
          this.waiting = false
        }, 500)
      }, 'image/jpeg')
    })
  }

  beforeScreenshot () {
    this.squares.forEach((s) => { s.visible = false })
  }

  afterScreenshot () {
    this.resetCanvasScale()
    this.squares.forEach((s) => { s.visible = true })
  }

  render () {
    if (this.wait) {
      this.waiting = true
      this.wait = false
    }

    if (!this.waiting) {
      this.dragContainer.position.set(this.dragHitArea.position.x, this.dragHitArea.position.y)
      this.collage.proj.mapSprite(this.collage, this.quad)
    }
  }

  addObjects (bgId, collId) {
    const w = this.w
    const h = this.h

    // todo: set default from prismic dynamicaly
    // this.bgTxt = this.texCache.larsenal
    this.bgContainer = new PIXI.Container()
    this.background = PIXI.Sprite.from(PIXI.Texture.WHITE)
    this.setBackgound(bgId)
    this.bgContainer.addChild(this.background)
    this.app.stage.addChild(this.bgContainer)
    this.background.name = 'background'

    this.outlineFilter = new OutlineFilter(20, 0xFF0000)
    this.outlineFilter.padding = 10
    // this.background.filters = [this.outlineFilter]

    this.dragContainer = new PIXI.Container()
    this.bgContainer.addChild(this.dragContainer)

    this.collageTxt = this.texCache[collId]
    this.cacheSprite = new PIXI.Sprite(PIXI.Texture.WHITE)

    this.squares = [
      this.createSquare(w - 150, h - 150, 0),
      this.createSquare(w + 150, h - 150, 90),
      this.createSquare(w + 150, h + 150, 180),
      this.createSquare(w - 150, h + 150, -90)
    ]
    this.squares.forEach((s) => { this.dragContainer.addChild(s) })
    this.squares.forEach((s) => { this.addInteraction(s) })

    this.quad = this.squares.map((s) => s.position)

    this.dragHitArea = new PIXI.Graphics()
    // this.dragHitArea.anchor.set(0.5)
    const posX = this.app.view.parentNode.offsetWidth * 0.5 - this.dragHitArea.width
    const posY = this.app.view.parentNode.offsetHeight * 0.5 - this.dragHitArea.height
    this.dragHitArea.position.set(posX, posY)
    this.dragHitArea.alpha = 0
    this.bgContainer.addChild(this.dragHitArea)

    this.dragHitArea.interactive = true
    this.dragHitArea
      .on('pointerdown', this.onDragStart)
      .on('pointerup', this.onDragEnd)
      .on('pointerupoutside', this.onDragEnd)
      .on('pointermove', this.onDragMove)
    // this.collage.anchor.set(0.5)
    this.background.interactive = true
    this.background
      .on('pointerdown', this.onDragStart)
      .on('pointerup', this.onDragEnd)
      .on('pointerupoutside', this.onDragEnd)
      .on('pointermove', this.onDragMove)

    // this.pinchEvent = new PinchEvent()

    this.collage = new PIXI.projection.Sprite2d(this.collageTxt)
    // this.tempSprite
    // this.collage.tint = 0xff00ff
    this.collage.anchor.set(0.5)

    this.dragContainer.addChild(this.collage)
    this.setCollage(collId)

    this.adaptSquare(this.cacheSprite, this.squares)
    this.updateDragHitArea()

    // this.viewport.addChild(this.collage)
  }

  applyTempToQuad () {

  }

  removeEvents () {
    this.dragHitArea
      .off('pointerdown', this.onDragStart)
      .off('pointerup', this.onDragEnd)
      .off('pointerupoutside', this.onDragEnd)
      .off('pointermove', this.onDragMove)
  }

  zoomIn () {
    // this.dragHitArea.scale.set()
  }

  zoomOut () {

  }

  mapSprite (sprite, quad) {
    const tex = sprite.texture
    const tempRect = new PIXI.Rectangle()

    tempRect.x = -sprite.anchor.x * tex.orig.width
    tempRect.y = -sprite.anchor.y * tex.orig.height
    tempRect.width = tex.orig.width
    tempRect.height = tex.orig.height

    return sprite.proj.mapQuad(tempRect, quad)
  }

  onCollageChange (sentence) {
    if (!this.texCache[sentence.uid]) {
      this.preload([
        { id: sentence.uid, url: sentence.url }
      ]).then((ressources) => {
        this.setCollage(sentence.uid)
      })
    } else {
      this.setCollage(sentence.uid)
    }
  }

  setCollage (uid) {
    const newTexture = this.texCache[uid]
    this.collage.texture = newTexture

    const prop = this.device.isMobile ? 0.7 : 0.4
    const ratio = newTexture.baseTexture.width / newTexture.baseTexture.height
    const w = this.app.view.parentNode.offsetWidth * prop

    this.cacheSprite.width = w
    this.cacheSprite.height = w / ratio

    this.adaptSquare(this.cacheSprite, this.squares)
    this.updateDragHitArea()
  }

  async onBgChange (place) {
    if (!this.texCache[place.uid]) {
      await this.preload([
        { id: place.uid, url: place.url }
      ])

      // this.preload([
      //   { id: place.uid, url: place.url }
      // ]).then((ressources) => {
      //   this.background.texture = this.texCache[place.uid]
      // })
    }

    this.setBackgound(place.uid)
    // this.background.height = 300
  }

  setBackgound (id) {
    this.background.texture = this.texCache[id]
    this.background.texture.update()
    const imageRatio = this.background.width / this.background.height
    this.resizeFullsizeSprite(this.background, this.app, imageRatio)
  }

  preload (data) {
    return new Promise((resolve, reject) => {
      data.forEach((d) => {
        this.loader.add(d.id, d.url)
      })
      this.loader.load((loader, resources) => {
        resolve(resources)
      })
    })
  }

  updateDragHitArea () {
    const quad = this.quad
    const path = [quad[0].x + 5, quad[0].y + 5, quad[1].x - 5, quad[1].y + 5, quad[2].x - 5, quad[2].y - 5, quad[3].x + 5, quad[3].y - 5]

    this.dragHitArea.clear()
    this.dragHitArea.lineStyle(1)
    this.dragHitArea.beginFill(0x3500FA, 1)
    this.dragHitArea.drawPolygon(path)
    this.dragHitArea.endFill()
  }

  adaptSquare (container, quads) {
    const b = {
      x: container.position.x - container.width * 0.5,
      y: container.position.y - container.height * 0.5,
      width: container.width,
      height: container.height
    }
    // console.log('==', b.width)
    const m = 0
    quads[0].position.set(b.x - m, b.y - m)
    quads[1].position.set(b.x + b.width + m, b.y - m)
    quads[2].position.set(b.x + b.width + m, b.y + b.height + m)
    quads[3].position.set(b.x - m, b.y + b.height + m)
  }

  createSquare (x, y, angle) {
    const square = new PIXI.Sprite(this.texCache['collage-corner']) // PIXI.Texture.WHITE)
    square.tint = 0xff0000
    square.factor = 1

    const size = this.device.isMobile ? 35 : 30
    square.width = size
    square.height = size
    square.angle = angle
    square.zIndex = 50
    // square.alpha = 0.5

    square.anchor.set(0.5)
    square.position.set(x, y)
    return square
  }

  resize () {
    const w = this.app.view.parentNode.offsetWidth
    const h = this.app.view.parentNode.offsetHeight
    // console.log(this.app.view.parentNode, w, h)
    this.app.renderer.resize(w, h)
    this.resizeFullsizeSprite(this.background, this.app)
  }

  resetScale () {
    this.origins.w = this.bgContainer.width
    this.origins.h = this.bgContainer.height
    this.bgContainer.width = this.background.texture.width
    this.bgContainer.height = this.background.texture.height
  }

  resetCanvasScale () {
    this.bgContainer.width = this.origins.w
    this.bgContainer.height = this.origins.h
  }

  setQuadOrigialSize (scale) {
    for (let i = 0; i < this.quad.length; i++) {
      const q = this.quad[i]
      q.x = 0
      q.y = 0
      // q.y *= scale
    }
  }

  resizeFullsizeSprite (sprite, app) {
    const containerWidth = app.screen.width
    const containerHeight = app.screen.height

    const h = sprite.texture.height
    const w = sprite.texture.width
    const imageRatio = w / h
    const containerRatio = containerWidth / containerHeight

    if (containerRatio > imageRatio) {
      sprite.height = h / (w / containerWidth)
      sprite.width = containerWidth
      sprite.position.x = 0
      sprite.position.y = (containerHeight - sprite.height) / 2
    } else {
      sprite.width = w / (h / containerHeight)
      sprite.height = containerHeight
      sprite.position.y = 0
      sprite.position.x = (containerWidth - sprite.width) / 2
    }
  }

  addInteraction (obj) {
    obj.interactive = true
    obj
      .on('pointerdown', this.onDragStart)
      .on('pointerup', this.onDragEnd)
      .on('pointerupoutside', this.onDragEnd)
      .on('pointermove', this.onDragMove)
      .on('mouseover', this.onMouseOver)
      .on('mouseout', this.onMouseLeave)
  }

  onMouseLeave (event) {
    const obj = event.currentTarget
    obj.width = 30
    obj.height = 30
  }

  onMouseOver (event) {
    // console.log('mouse enter')
    const obj = event.currentTarget
    obj.width = 35
    obj.height = 35
  }

  onDragStart (event) {
    const obj = event.currentTarget
    // console.log(obj)
    document.body.style.cursor = 'move'
    obj.dragData = event.data
    obj.dragging = 1
    obj.dragPointerStart = event.data.getLocalPosition(obj.parent)
    obj.dragObjStart = new PIXI.Point()
    obj.dragObjStart.copyFrom(obj.position)
    obj.dragGlobalStart = new PIXI.Point()
    obj.dragGlobalStart.copyFrom(event.data.global)

    // this.pinchEvent.onPointerDown(event)
  }

  onDragEndPosition (event) {
    const obj = event.currentTarget
    // this.alpha = 1;
    obj.dragging = 0
    obj.dragData = null

    // this.pinchEvent.onPointerUp(event)
  }

  onDragEnd (event) {
    const obj = event.currentTarget

    obj.dragging = 0
    obj.dragData = null

    this.updateDragHitArea()

    document.body.style.cursor = 'default'
  }

  onDragMove (event) {
    const obj = event.currentTarget
    // this.pinchEvent.onPointerMove(event)
    if (!obj.dragging) return
    const data = obj.dragData // it can be different pointer!

    if (obj.dragging === 1) {
      // click or drag?
      if (Math.abs(data.global.x - obj.dragGlobalStart.x) + Math.abs(data.global.y - obj.dragGlobalStart.y) >= 3) {
        // DRAG
        obj.dragging = 2
      }
    }
    if (obj.dragging === 2) {
      const dragPointerEnd = data.getLocalPosition(obj.parent)
      // DRAG
      const boundsX = [10, Math.abs(this.app.view.parentNode.offsetWidth - obj.width) + 10]
      const boundsY = [10, Math.abs(this.app.view.parentNode.offsetHeight - obj.height) + 10]
      const x = obj.dragObjStart.x + (dragPointerEnd.x - obj.dragPointerStart.x)
      const y = obj.dragObjStart.y + (dragPointerEnd.y - obj.dragPointerStart.y)
      if (obj.name === 'background') {
        if (x < boundsX[0] && x > -boundsX[1]) {
          obj.position.x = x
        }
        if (y < boundsY[0] && y > -boundsY[1]) {
          obj.position.y = y
        }
      } else {
        obj.position.set(
          x,
          y
        )
      }
    }

    // this.mapSprite(this.collage, this.quad)
  }
}
